import { z } from "zod";

type IssueLike = Record<string, unknown>;

const getIssueCode = (issue: IssueLike): string =>
  typeof issue.code === "string" ? issue.code : "";

function handleInvalidFormat(issue: IssueLike): string | null {
  const format = typeof issue.format === "string" ? issue.format : undefined;
  if (format === "email") return "Email không hợp lệ";
  if (format === "url") return "Đường dẫn không hợp lệ";
  if (format === "regex") return "Dữ liệu không đúng định dạng";
  return null;
}

function handleTooSmall(issue: IssueLike): string | null {
  if (issue.origin !== "string") return null;
  const minimum = typeof issue.minimum === "number" ? issue.minimum : undefined;
  if (!minimum) return null;
  if (minimum === 1) return "Trường này là bắt buộc";
  return `Phải có ít nhất ${minimum} ký tự`;
}

function handleTooBig(issue: IssueLike): string | null {
  if (issue.origin !== "string") return null;
  const maximum = typeof issue.maximum === "number" ? issue.maximum : undefined;
  if (!maximum) return null;
  return `Không được quá ${maximum} ký tự`;
}

const customErrorMap = (issue: IssueLike) => {
  const code = getIssueCode(issue);

  if (code === "invalid_type" && issue.expected === "string") {
    return { message: "Trường này là bắt buộc" };
  }

  if (code === "too_small") {
    const msg = handleTooSmall(issue);
    if (msg) return { message: msg };
  }

  if (code === "too_big") {
    const msg = handleTooBig(issue);
    if (msg) return { message: msg };
  }

  if (code === "invalid_format") {
    const msg = handleInvalidFormat(issue);
    if (msg) return { message: msg };
  }

  if (code === "custom") {
    const message = typeof issue.message === "string" ? issue.message : "";
    return { message: message || "Dữ liệu không hợp lệ" };
  }

  const fallback =
    typeof issue.message === "string" ? issue.message : "Dữ liệu không hợp lệ";
  return { message: fallback };
};

export function registerZodErrorMap() {
  z.config({ customError: customErrorMap });
}
